import type { StayState } from './types';

const getStay = (state: StayState) => state;

export default {
  getStay,
};
